// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawer-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(36, 41, 57, 0.25);
    opacity: 0;
    pointer-events: none;
    z-index: 40;
    transition: opacity 0.25s;
}
.drawer-backdrop.open {
    opacity: 1;
    pointer-events: all;
}

.drawer-menu {
    position: fixed;
    top: 0;
    right: -290px;
    width: 260px;
    height: 100vh;
    background: #fff;
    box-shadow: -2px 0 22px rgba(36,41,57,0.15);
    z-index: 50;
    transition: right 0.33s cubic-bezier(.57,.21,.69,.92);
    display: flex;
    flex-direction: column;
    padding: 28px 18px 12px 18px;
}
.drawer-menu.open {
    right: 0;
}
.drawer-close {
    background: none;
    border: none;
    font-size: 2rem;
    color: #232137;
    align-self: flex-end;
    margin-bottom: 18px;
    cursor: pointer;
    line-height: 1;
}
.drawer-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
.drawer-menu li {
    margin-bottom: 18px;
}
.drawer-menu a {
    color: #232137;
    text-decoration: none;
    font-family: 'Cera Pro', Arial, sans-serif;
    font-size: 1.16rem;
    font-weight: 600;
    transition: color 0.15s;
}
.drawer-menu a:hover {
    color: #e72f44;
}
/* Drawer Backdrop + меню (современный стиль) */
.drawer-backdrop.modern {
    position: fixed;
    inset: 0;
    background: rgba(36, 41, 57, 0.28);
    backdrop-filter: blur(2.5px);
    opacity: 0;
    pointer-events: none;
    z-index: 40;
    transition: opacity 0.33s cubic-bezier(.77,.18,.71,.82);
}
.drawer-backdrop.modern.open {
    opacity: 1;
    pointer-events: all;
}

/* Меню */
.drawer-menu.modern {
    position: fixed;
    top: 0;
    left: 0;
    right: auto;
    width: 300px;
    max-width: 92vw;
    box-sizing: border-box;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    overflow: hidden;
    overscroll-behavior: contain;
    background: rgba(255,255,255,0.98);
    border-radius: 0 28px 28px 0; /* Скругление справа */
    box-shadow: 8px 0 34px 0 rgba(36,41,57,0.14), 2px 0 14px 0 rgba(231,47,68,0.04);
    z-index: 50;
    display: flex;
    flex-direction: column;
    padding: 36px 26px 22px 26px;
    backdrop-filter: blur(8px);
    opacity: 0;
    transform: translateX(-105%) scale(0.96);
    pointer-events: none;
    transition:
            opacity 0.33s cubic-bezier(.45,.12,.39,1.18),
            transform 0.44s cubic-bezier(.52,.09,.33,1.02);
}
.drawer-menu.modern.open {
    left: 0;
    right: auto;
    opacity: 1;
    transform: translateX(0) scale(1);
    pointer-events: all;
}

/* Крестик-кнопка */
.drawer-close.modern {
    background: none;
    border: none;
    padding: 0;
    margin: 0 0 24px 0;
    align-self: flex-end;
    flex: 0 0 auto;
    cursor: pointer;
    border-radius: 50%;
    box-shadow: 0 2px 8px 0 rgba(231,47,68,0.07);
    transition: box-shadow .17s, transform .14s;
}
.drawer-close.modern:active {
    box-shadow: 0 2px 18px 0 rgba(231,47,68,0.14);
    transform: scale(0.93);
}

/* Список меню */
.drawer-menu.modern ul {
    list-style: none;
    padding: 0;
    margin: 0;
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    touch-action: pan-y;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: rgba(231, 47, 68, 0.35) transparent;
}
.drawer-menu.modern ul::-webkit-scrollbar {
    width: 4px;
}
.drawer-menu.modern ul::-webkit-scrollbar-thumb {
    background: rgba(231, 47, 68, 0.35);
    border-radius: 999px;
}
.drawer-menu.modern li {
    margin-bottom: 22px;
    border-radius: 14px;
    transition: background .18s;
}
.drawer-menu.modern a {
    display: flex;
    align-items: center;
    gap: 13px;
    color: #232137;
    text-decoration: none;
    font-family: 'Cera Pro', Arial, sans-serif;
    font-size: 1.18rem;
    font-weight: 600;
    padding: 11px 14px 11px 11px;
    border-radius: 14px;
    transition: color 0.13s, background 0.16s, box-shadow 0.16s;
    box-shadow: 0 1px 8px 0 rgba(35,33,55,0.05);
}
.drawer-menu.modern a:hover, .drawer-menu.modern a:focus {
    background: #f8f8fa;
    color: #232137;
    box-shadow: 0 3px 16px 0 rgba(35,33,55,0.09);
}
.menu-icon {
    font-size: 1.33em;
    margin-right: 2px;
    opacity: .95;
    transition: color 0.18s;
}

/* Супербургер с micro-animation */
.header-menu {
    transition: transform .16s;
    position: relative;
    z-index: 60;
}
.header-menu:active {
    transform: scale(0.94) rotate(-2deg);
}
.header-menu span {
    transition: background 0.2s, transform 0.25s cubic-bezier(.76,.04,.76,.79);
}

/* При открытом меню — бургер превращается в крестик */
.menu-open .header-menu span:nth-child(1) {
    transform: translateY(7.6px) rotate(45deg);
}
.menu-open .header-menu span:nth-child(2) {
    opacity: 0;
}
.menu-open .header-menu span:nth-child(3) {
    transform: translateY(-7.6px) rotate(-45deg);
}

/* Улучшения для header и кнопок */
.app-header {
    box-shadow: 0 8px 36px 0 rgba(36,41,57,0.17);
    transition: box-shadow .2s;
}
.header-logo-group .logo-img svg circle {
    filter: drop-shadow(0 2px 10px #e72f4440);
}

.make-layout-btn, .support-btn {
    box-shadow: 0 2px 22px 0 rgba(36,41,57,0.10);
    transition: background 0.18s, box-shadow 0.19s;
}
.make-layout-btn:active, .support-btn:active {
    background: #e72f44;
    color: #fff;
    box-shadow: 0 4px 26px 0 rgba(231,47,68,0.15);
}

@media (max-width: 700px) {
    .drawer-menu.modern {
        padding:
            calc(20px + env(safe-area-inset-top))
            11px
            calc(12px + env(safe-area-inset-bottom))
            14px;
    }
    .drawer-close.modern {
        margin-bottom: 14px;
    }
    .drawer-menu.modern .drawer-user-block {
        margin-bottom: 16px;
    }
    .drawer-menu.modern li {
        margin-bottom: 14px;
    }
}
/* Blur для ВСЕГО контента приложения */
.menu-open .container,
.menu-open .app-header {
    filter: blur(8px) grayscale(0.1) brightness(0.98);
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    transition: filter 0.33s cubic-bezier(.66,.22,.55,1.02);
}
.menu-open .container,
.menu-open .app-header {
    will-change: filter;
}

/* Drawer User */
.drawer-user-block {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    margin-bottom: 30px;
    gap: 13px;
    padding: 7px 8px 8px;
    border-bottom: 1.5px solid #f1f2f4;
}
.drawer-user-block.clickable {
    cursor: pointer;
    border-radius: 12px;
}
.drawer-user-block.clickable:hover {
    background: #f7f9fb;
}
.drawer-user-avatar {
    width: 52px;
    height: 52px;
    flex: 0 0 52px;
    box-sizing: border-box;
    border-radius: 50%;
    object-fit: cover;
    background: #f0f2f5;
    box-shadow: 0 4px 18px 0 rgba(36,41,57,0.11);
    border: 3px solid #e72f44;
}
.drawer-user-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 2px;
}
.drawer-user-name {
    font-size: 1.14rem;
    font-weight: 700;
    color: #232137;
    margin-bottom: 1.5px;
    letter-spacing: 0.01em;
    font-family: 'Cera Pro', Arial, sans-serif;
}
.drawer-user-role {
    font-size: 0.99rem;
    color: #e72f44;
    opacity: 0.95;
    font-family: 'Cera Pro', Arial, sans-serif;
}
.drawer-user-company {
    overflow: hidden;
    color: #8a8a9a;
    font-size: 0.9rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.drawer-user-error {
    color: #e72f44;
    font-size: 0.9rem;
}
.drawer-user-avatar.fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #232137;
    font-weight: 700;
}
.drawer-user-avatar.skeleton {
    animation: drawer-pulse 1.2s infinite;
}
.menu-icon {
    width: 24px;
    flex: 0 0 24px;
    margin-right: 8px;
    text-align: center;
}
.drawer-menu.modern .menu-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    margin-right: 4px;
    opacity: 1;
}
.drawer-menu.modern .menu-icon svg {
    display: block;
}
@keyframes drawer-pulse {
    0%, 100% { opacity: 0.6; }
    50% { opacity: 1; }
}

/* Drawer Fade + Slide + Scale Animation */
.drawer-menu.modern {
    opacity: 0;
    transform: translateX(-105%) scale(0.96);
    pointer-events: none;
    transition:
            opacity 0.33s cubic-bezier(.45,.12,.39,1.18),
            transform 0.44s cubic-bezier(.52,.09,.33,1.02);
}
.drawer-menu.modern.open {
    opacity: 1;
    transform: translateX(0) scale(1);
    pointer-events: all;
}

.drawer-backdrop.modern {
    /* УЖЕ есть плавное появление, плюс blur */
    transition: opacity 0.33s cubic-bezier(.77,.18,.71,.82), backdrop-filter 0.36s;
    backdrop-filter: blur(2.5px);
}
.drawer-backdrop.modern.open {
    backdrop-filter: blur(7px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,UAAU;IACV,oBAAoB;IACpB,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,aAAa;IACb,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,2CAA2C;IAC3C,WAAW;IACX,qDAAqD;IACrD,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB;AACA,+CAA+C;AAC/C;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,4BAA4B;IAC5B,UAAU;IACV,oBAAoB;IACpB,WAAW;IACX,uDAAuD;AAC3D;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA,SAAS;AACT;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,kCAAkC;IAClC,4BAA4B,EAAE,sBAAsB;IACpD,+EAA+E;IAC/E,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,UAAU;IACV,wCAAwC;IACxC,oBAAoB;IACpB;;0DAEsD;AAC1D;AACA;IACI,OAAO;IACP,WAAW;IACX,UAAU;IACV,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,4CAA4C;IAC5C,2CAA2C;AAC/C;AACA;IACI,6CAA6C;IAC7C,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;IACrB,oDAAoD;AACxD;AACA;IACI,UAAU;AACd;AACA;IACI,mCAAmC;IACnC,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,qBAAqB;IACrB,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,2DAA2D;IAC3D,2CAA2C;AAC/C;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,4CAA4C;AAChD;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA,kCAAkC;AAClC;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,oCAAoC;AACxC;AACA;IACI,0EAA0E;AAC9E;;AAEA,sDAAsD;AACtD;IACI,0CAA0C;AAC9C;AACA;IACI,UAAU;AACd;AACA;IACI,4CAA4C;AAChD;;AAEA,kCAAkC;AAClC;IACI,4CAA4C;IAC5C,0BAA0B;AAC9B;AACA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4CAA4C;IAC5C,8CAA8C;AAClD;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI;QACI;;;;gBAIQ;IACZ;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA,uCAAuC;AACvC;;IAEI,iDAAiD;IACjD,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,uDAAuD;AAC3D;AACA;;IAEI,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,4CAA4C;IAC5C,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW,YAAY,EAAE;IACzB,MAAM,UAAU,EAAE;AACtB;;AAEA,0CAA0C;AAC1C;IACI,UAAU;IACV,wCAAwC;IACxC,oBAAoB;IACpB;;0DAEsD;AAC1D;AACA;IACI,UAAU;IACV,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,8EAA8E;IAC9E,4BAA4B;AAChC;AACA;IACI,0BAA0B;AAC9B","sourcesContent":[".drawer-backdrop {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(36, 41, 57, 0.25);\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    z-index: 40;\r\n    transition: opacity 0.25s;\r\n}\r\n.drawer-backdrop.open {\r\n    opacity: 1;\r\n    pointer-events: all;\r\n}\r\n\r\n.drawer-menu {\r\n    position: fixed;\r\n    top: 0;\r\n    right: -290px;\r\n    width: 260px;\r\n    height: 100vh;\r\n    background: #fff;\r\n    box-shadow: -2px 0 22px rgba(36,41,57,0.15);\r\n    z-index: 50;\r\n    transition: right 0.33s cubic-bezier(.57,.21,.69,.92);\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 28px 18px 12px 18px;\r\n}\r\n.drawer-menu.open {\r\n    right: 0;\r\n}\r\n.drawer-close {\r\n    background: none;\r\n    border: none;\r\n    font-size: 2rem;\r\n    color: #232137;\r\n    align-self: flex-end;\r\n    margin-bottom: 18px;\r\n    cursor: pointer;\r\n    line-height: 1;\r\n}\r\n.drawer-menu ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n.drawer-menu li {\r\n    margin-bottom: 18px;\r\n}\r\n.drawer-menu a {\r\n    color: #232137;\r\n    text-decoration: none;\r\n    font-family: 'Cera Pro', Arial, sans-serif;\r\n    font-size: 1.16rem;\r\n    font-weight: 600;\r\n    transition: color 0.15s;\r\n}\r\n.drawer-menu a:hover {\r\n    color: #e72f44;\r\n}\r\n/* Drawer Backdrop + меню (современный стиль) */\r\n.drawer-backdrop.modern {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(36, 41, 57, 0.28);\r\n    backdrop-filter: blur(2.5px);\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    z-index: 40;\r\n    transition: opacity 0.33s cubic-bezier(.77,.18,.71,.82);\r\n}\r\n.drawer-backdrop.modern.open {\r\n    opacity: 1;\r\n    pointer-events: all;\r\n}\r\n\r\n/* Меню */\r\n.drawer-menu.modern {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: auto;\r\n    width: 300px;\r\n    max-width: 92vw;\r\n    box-sizing: border-box;\r\n    height: 100vh;\r\n    height: 100dvh;\r\n    max-height: 100vh;\r\n    max-height: 100dvh;\r\n    overflow: hidden;\r\n    overscroll-behavior: contain;\r\n    background: rgba(255,255,255,0.98);\r\n    border-radius: 0 28px 28px 0; /* Скругление справа */\r\n    box-shadow: 8px 0 34px 0 rgba(36,41,57,0.14), 2px 0 14px 0 rgba(231,47,68,0.04);\r\n    z-index: 50;\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 36px 26px 22px 26px;\r\n    backdrop-filter: blur(8px);\r\n    opacity: 0;\r\n    transform: translateX(-105%) scale(0.96);\n    pointer-events: none;\r\n    transition:\r\n            opacity 0.33s cubic-bezier(.45,.12,.39,1.18),\n            transform 0.44s cubic-bezier(.52,.09,.33,1.02);\n}\r\n.drawer-menu.modern.open {\r\n    left: 0;\r\n    right: auto;\r\n    opacity: 1;\r\n    transform: translateX(0) scale(1);\r\n    pointer-events: all;\r\n}\r\n\r\n/* Крестик-кнопка */\r\n.drawer-close.modern {\r\n    background: none;\r\n    border: none;\r\n    padding: 0;\r\n    margin: 0 0 24px 0;\r\n    align-self: flex-end;\r\n    flex: 0 0 auto;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    box-shadow: 0 2px 8px 0 rgba(231,47,68,0.07);\r\n    transition: box-shadow .17s, transform .14s;\r\n}\r\n.drawer-close.modern:active {\r\n    box-shadow: 0 2px 18px 0 rgba(231,47,68,0.14);\r\n    transform: scale(0.93);\r\n}\r\n\r\n/* Список меню */\r\n.drawer-menu.modern ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    overscroll-behavior: contain;\r\n    touch-action: pan-y;\r\n    -webkit-overflow-scrolling: touch;\r\n    scrollbar-width: thin;\r\n    scrollbar-color: rgba(231, 47, 68, 0.35) transparent;\r\n}\r\n.drawer-menu.modern ul::-webkit-scrollbar {\r\n    width: 4px;\r\n}\r\n.drawer-menu.modern ul::-webkit-scrollbar-thumb {\r\n    background: rgba(231, 47, 68, 0.35);\r\n    border-radius: 999px;\r\n}\r\n.drawer-menu.modern li {\r\n    margin-bottom: 22px;\r\n    border-radius: 14px;\r\n    transition: background .18s;\r\n}\r\n.drawer-menu.modern a {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 13px;\r\n    color: #232137;\r\n    text-decoration: none;\r\n    font-family: 'Cera Pro', Arial, sans-serif;\r\n    font-size: 1.18rem;\r\n    font-weight: 600;\r\n    padding: 11px 14px 11px 11px;\r\n    border-radius: 14px;\r\n    transition: color 0.13s, background 0.16s, box-shadow 0.16s;\r\n    box-shadow: 0 1px 8px 0 rgba(35,33,55,0.05);\n}\r\n.drawer-menu.modern a:hover, .drawer-menu.modern a:focus {\n    background: #f8f8fa;\n    color: #232137;\n    box-shadow: 0 3px 16px 0 rgba(35,33,55,0.09);\n}\n.menu-icon {\r\n    font-size: 1.33em;\r\n    margin-right: 2px;\r\n    opacity: .95;\r\n    transition: color 0.18s;\r\n}\r\n\r\n/* Супербургер с micro-animation */\r\n.header-menu {\r\n    transition: transform .16s;\r\n    position: relative;\r\n    z-index: 60;\r\n}\r\n.header-menu:active {\r\n    transform: scale(0.94) rotate(-2deg);\r\n}\r\n.header-menu span {\r\n    transition: background 0.2s, transform 0.25s cubic-bezier(.76,.04,.76,.79);\r\n}\r\n\r\n/* При открытом меню — бургер превращается в крестик */\r\n.menu-open .header-menu span:nth-child(1) {\r\n    transform: translateY(7.6px) rotate(45deg);\r\n}\r\n.menu-open .header-menu span:nth-child(2) {\r\n    opacity: 0;\r\n}\r\n.menu-open .header-menu span:nth-child(3) {\r\n    transform: translateY(-7.6px) rotate(-45deg);\r\n}\r\n\r\n/* Улучшения для header и кнопок */\r\n.app-header {\r\n    box-shadow: 0 8px 36px 0 rgba(36,41,57,0.17);\r\n    transition: box-shadow .2s;\r\n}\r\n.header-logo-group .logo-img svg circle {\r\n    filter: drop-shadow(0 2px 10px #e72f4440);\r\n}\r\n\r\n.make-layout-btn, .support-btn {\r\n    box-shadow: 0 2px 22px 0 rgba(36,41,57,0.10);\r\n    transition: background 0.18s, box-shadow 0.19s;\r\n}\r\n.make-layout-btn:active, .support-btn:active {\r\n    background: #e72f44;\r\n    color: #fff;\r\n    box-shadow: 0 4px 26px 0 rgba(231,47,68,0.15);\r\n}\r\n\r\n@media (max-width: 700px) {\r\n    .drawer-menu.modern {\r\n        padding:\r\n            calc(20px + env(safe-area-inset-top))\r\n            11px\r\n            calc(12px + env(safe-area-inset-bottom))\r\n            14px;\r\n    }\r\n    .drawer-close.modern {\r\n        margin-bottom: 14px;\r\n    }\r\n    .drawer-menu.modern .drawer-user-block {\r\n        margin-bottom: 16px;\r\n    }\r\n    .drawer-menu.modern li {\r\n        margin-bottom: 14px;\r\n    }\r\n}\r\n/* Blur для ВСЕГО контента приложения */\r\n.menu-open .container,\r\n.menu-open .app-header {\r\n    filter: blur(8px) grayscale(0.1) brightness(0.98);\r\n    pointer-events: none;\r\n    user-select: none;\r\n    transition: filter 0.33s cubic-bezier(.66,.22,.55,1.02);\r\n}\r\n.menu-open .container,\r\n.menu-open .app-header {\r\n    will-change: filter;\r\n}\r\n\r\n/* Drawer User */\r\n.drawer-user-block {\r\n    display: flex;\r\n    align-items: center;\r\n    flex: 0 0 auto;\r\n    margin-bottom: 30px;\r\n    gap: 13px;\r\n    padding: 7px 8px 8px;\r\n    border-bottom: 1.5px solid #f1f2f4;\r\n}\r\n.drawer-user-block.clickable {\r\n    cursor: pointer;\r\n    border-radius: 12px;\r\n}\r\n.drawer-user-block.clickable:hover {\r\n    background: #f7f9fb;\r\n}\r\n.drawer-user-avatar {\r\n    width: 52px;\r\n    height: 52px;\r\n    flex: 0 0 52px;\r\n    box-sizing: border-box;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n    background: #f0f2f5;\r\n    box-shadow: 0 4px 18px 0 rgba(36,41,57,0.11);\r\n    border: 3px solid #e72f44;\r\n}\r\n.drawer-user-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 0;\r\n    gap: 2px;\r\n}\r\n.drawer-user-name {\r\n    font-size: 1.14rem;\r\n    font-weight: 700;\r\n    color: #232137;\r\n    margin-bottom: 1.5px;\r\n    letter-spacing: 0.01em;\r\n    font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n.drawer-user-role {\r\n    font-size: 0.99rem;\r\n    color: #e72f44;\r\n    opacity: 0.95;\r\n    font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n.drawer-user-company {\r\n    overflow: hidden;\r\n    color: #8a8a9a;\r\n    font-size: 0.9rem;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n.drawer-user-error {\r\n    color: #e72f44;\r\n    font-size: 0.9rem;\r\n}\r\n.drawer-user-avatar.fallback {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #232137;\r\n    font-weight: 700;\r\n}\r\n.drawer-user-avatar.skeleton {\r\n    animation: drawer-pulse 1.2s infinite;\r\n}\r\n.menu-icon {\n    width: 24px;\n    flex: 0 0 24px;\n    margin-right: 8px;\n    text-align: center;\n}\n.drawer-menu.modern .menu-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    flex: 0 0 28px;\n    margin-right: 4px;\n    opacity: 1;\n}\n.drawer-menu.modern .menu-icon svg {\n    display: block;\n}\n@keyframes drawer-pulse {\r\n    0%, 100% { opacity: 0.6; }\r\n    50% { opacity: 1; }\r\n}\r\n\r\n/* Drawer Fade + Slide + Scale Animation */\r\n.drawer-menu.modern {\n    opacity: 0;\n    transform: translateX(-105%) scale(0.96);\n    pointer-events: none;\r\n    transition:\r\n            opacity 0.33s cubic-bezier(.45,.12,.39,1.18),\r\n            transform 0.44s cubic-bezier(.52,.09,.33,1.02);\r\n}\r\n.drawer-menu.modern.open {\r\n    opacity: 1;\r\n    transform: translateX(0) scale(1);\r\n    pointer-events: all;\r\n}\r\n\r\n.drawer-backdrop.modern {\r\n    /* УЖЕ есть плавное появление, плюс blur */\r\n    transition: opacity 0.33s cubic-bezier(.77,.18,.71,.82), backdrop-filter 0.36s;\r\n    backdrop-filter: blur(2.5px);\r\n}\r\n.drawer-backdrop.modern.open {\r\n    backdrop-filter: blur(7px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
